module.exports = __webpack_public_path__ + "static/img/s33.7d40c5a4.png";